import type { paths } from '../../types/clients/marketing-automation'
import { useOpenapi } from '#imports'

/**
 * @title useMarketingAutomationClient
 * @see Docs https://marketing-automation-stage.spilnu.dk/api#/
 */
export const useMarketingAutomationClient = () => {
    const client = useOpenapi<paths>({
        baseUrl: '/gateway/marketing-automation/api',
        service: 'marketingAutomation'
    })

    return {
        client,
    }
}
